import React from "react";
import Bet from "../../common/Bet";
import BetsGroup from "../../common/BetGroup";
import OddWithDesc from '../../common/OddWithDesc';
import ScorerMarket from "../../common/Scorer";
import { hasTemplate } from '../../data/bet-templates/bet-templates';
import BetWrapper from "../../common/BetWrapper";
import BetOddsWrapper from "../../common/BetOddsWrapper";
import OddSelector from "../../common/OddSelector";
import { xs_isMobile } from "../..";

export default function Bets(props) {
    const groups = [];
    const betsById = new Map();
    props.bets.forEach(b => {
        if (!b.hasOdds) {
            return;
        }
        const sportRef = b.odds[0].matchData.sportRef;
        if (hasTemplate(sportRef, b.id) || b.dia?.length > 0) {
            if (!betsById.has(b.id)) {
                const group = [];
                betsById.set(b.id, group);
                groups.push(group);
            }
            betsById.get(b.id).push(b);
        } else {
            groups.push([b]);
        }
    });

    return (
        <>
            {/* <RenderOnScroll start={10} increment={5}>
            </RenderOnScroll> */}
            {groups.map((bets, index) => {
                const b = bets[0];
                const isToggled = index < 4;
                if (bets.length === 1) {
                    if (xs_isMobile && b.odds.length > 3) {
                        return (
                            <BetWrapper key={b.uniqueId} data={b} toggled={isToggled}>
                                <BetOddsWrapper>
                                    <OddSelector odds={b.odds} />
                                </BetOddsWrapper>
                            </BetWrapper>
                        );
                    }
                    return (
                        <Bet key={b.uniqueId} data={b} toggled={isToggled}>
                            {b.odds.map(o =>
                                <OddWithDesc key={o.uniqueId} data={o} />
                            )}
                        </Bet>
                    );
                } else if (b.dia?.length > 0) {
                    return <ScorerMarket key={index} bets={bets} team1={props.team1} team2={props.team2} toggled={isToggled} />;
                } else {
                    return <BetsGroup key={index} bets={bets} toggled={isToggled} />;
                }
            })}
        </>
    );
}
